import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'
import LoadingSpinner from '../components/common/LoadingSpinner'

function AdminRoute() {
  const { user, loading } = useAuthStore()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    )
  }

  // Check if user is admin
  const isAdminRole = user?.role === 'admin'
  const envAdminEmail = import.meta.env.VITE_ADMIN_EMAIL
  const normalize = (s) => (s ? String(s).trim().toLowerCase() : '')
  const isEnvAdmin = envAdminEmail && normalize(user?.email) === normalize(envAdminEmail)
  const isAdmin = isAdminRole || isEnvAdmin

  if (!user) {
    return <Navigate to="/auth/login?next=/admin" replace />
  }
  return isAdmin ? <Outlet /> : <Navigate to="/dashboard" replace />
}

export default AdminRoute
